import { ACTION_NAME__LOGIN } from '@newswebsiteapp/shared/lib/appVerifyRecaptchaActionNames'
import controllerLoadedObservableFactory from '@newswebsiteapp/shared/observables/controllerLoadedObservableFactory'
import setupOtpField from '@newswebsiteapp/shared/lib/setupOtpField'
import {
  googleRecaptchaRenderWidget,
  grecaptchaGetResponseOrDisableForTests,
} from '@newswebsiteapp/shared/lib/googleRecaptchaTokenForAction'

controllerLoadedObservableFactory('sign_in').subscribe(async () => {
  console.log('controllerLoadedObservableFactory("sign_in") loaded')

  const form = $('#new_user').expectLength()
  const new_google_recaptcha_tokenInput = form
    .find('[data-google-recaptcha-action]')
    .expectLength()

  console.log(form)
  console.log(new_google_recaptcha_tokenInput)
  const grecaptchaWidget = await googleRecaptchaRenderWidget(
    `recaptcha_action_tag__${ACTION_NAME__LOGIN}__id`,
  )

  form
    .find('[type="submit"]')
    .expectLength()
    .off() // click should not follow. Or `event.preventDefault` not defined
    .click((event) => {
      // event.preventDefault(...) is not a function
      // event.preventDefault() // TODO: why `click(event => event.preventDefault()` works elsewhere???
      ; (async () => {
        const grecaptchaToken =
          grecaptchaGetResponseOrDisableForTests(grecaptchaWidget)
        console.log('grecaptchaToken', grecaptchaToken)
        if (!grecaptchaToken) {
          alert('First, pass recaptcha')
          return
        }
        // need to regenerate every submit, if page is not reloaded completely (because after first use - token becomes stale)
        new_google_recaptcha_tokenInput[0].value = grecaptchaToken
        console.log({
          grecaptchaToken,
          new_google_recaptcha_tokenInput,
          value: new_google_recaptcha_tokenInput[0].value,
        })
        console.log(JSON.stringify(form.serializeArray()))
        setTimeout(() => {
          form[0].requestSubmit()
        }, 0) // XXX: since form is REMOTE https://stackoverflow.com/questions/8570824/submit-a-rails-remote-form-with-javascript
      })()
      return false
    })

  setupOtpField({
    emailInput: form.find('input[type="email"]').expectLength(),
    otpFieldForm: form.find('.otp_nested_fields').expectLengthAtLeast(),
  })
})
